import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfFont,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';

export class Seznam implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 4;
  }
  countMax(): number {
    return 20;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const headerSize = PdfUnit.FromMillimeters(20);
    const checkSize = PdfUnit.FromMillimeters(6);
    const sp = PdfUnit.FromMillimeters(2);

    const sorted = [...opts.list].sort((a, b) => {
      const textA = a.left.getText() || '';
      const textB = b.left.getText() || '';
      return textA.localeCompare(textB);
    });

    const itemCount = Math.min(sorted.length, 20);

    const pages: PageGen[] = [];
    for (let i = 0; i < 3; i++) {
      pages.push(pdf.addPage(true));
    }

    for (let index = 0; index < 3; index++) {
      const page = pages[index];
      const parts = 2 + index;

      const margin = PdfUnit.FromMillimeters(Math.max(20 - parts * 5, 5));

      for (let p = 0; p < parts; p++) {
        const baseRect = new PdfRect(
          (p * PdfSize.A4H.width) / parts,
          0,
          PdfSize.A4H.width / parts,
          PdfSize.A4H.height
        );
        page.drawRectangle(GUtil.cutPen, null, baseRect);

        const headerRect = new PdfRect(
          baseRect.x + margin,
          baseRect.y,
          baseRect.width - 2 * margin,
          headerSize + margin
        );
        page.drawString(
          opts.data.lang.Generator_List ?? 'Seznam',
          GUtil.baseFont,
          PdfBrush.Black,
          null,
          headerRect,
          ETextAlign.BottomLeft
        );

        const rect = new PdfRect(
          baseRect.x + margin,
          baseRect.y + margin + headerSize,
          baseRect.width - 2 * margin,
          baseRect.height - 2 * margin - headerSize
        );

        const size = new PdfSize(rect.width, rect.height / itemCount);

        const imgSize = new PdfSize(size.height * 1.2, size.height);

        const labelTexts = sorted.slice(0, itemCount).map((item) => [item.left.getText() ?? '']);
        const labelFont =
          labelTexts.length > 0
            ? page.adjustFontMulti(labelTexts, GUtil.baseFont, imgSize)
            : GUtil.baseFont;

        for (let i = 0; i < itemCount && i < sorted.length; i++) {
          const r = new PdfRect(rect.x, rect.y + i * size.height, size.width, size.height);
          const imgRect = new PdfRect(r.x, r.y, imgSize.width, imgSize.height);

          page.drawLabel(sorted[i].left, { rect: imgRect, font: labelFont });

          const checkRect = new PdfRect(
            imgRect.x + imgRect.width + sp,
            r.y + (r.height - checkSize) / 2,
            checkSize,
            checkSize
          );
          page.drawRectangle(GUtil.basePen, null, checkRect);

          const lineY = r.y + r.height - PdfUnit.FromMillimeters(1);
          page.drawLine(
            GUtil.writePen,
            new PdfPoint(checkRect.right, lineY),
            new PdfPoint(r.right, lineY)
          );
        }
      }
    }
  }
}
